// CTASection.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-20 bg-[#202356]">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-gray-300 text-base font-light leading-relaxed mb-8 max-w-2xl mx-auto">
            The best way to receive accurate pricing is through a consultation where we can assess your profile and explain the level of support required.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-white hover:bg-gray-100 text-[#202356] font-normal text-base px-8 py-4 rounded-lg transition-colors"
          >
            Book a Consultation
            <ArrowRight size={20} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
